
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-management",
      function () {
        return require("private-next-pages/product-management.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-management"])
      });
    }
  